import React, { PropsWithChildren }     from 'react';
import { SemanticUIColor, Size }        from "@src/types";
import classNames                       from "classnames";
import { Cell, Grid }                   from "styled-css-grid";
import { Icon, Segment, SemanticICONS } from "semantic-ui-react";
import { StyledContainer }              from "@src/views/containers";
import { runIfFunction }                from "@src/util";


interface GenericEntitySelectionContainerLayoutProps extends PropsWithChildren<any> {
    id: any,
    iconName?: SemanticICONS,
    isSelected?: boolean,
    borderColor?: SemanticUIColor,
    borderColorSelected?: SemanticUIColor,
    onClick?: ( id:any ) => void,
}

const GenericEntitySelectionContainerLayoutDefaultProps = {
    id:                  null,
    iconName:            "box",
    isSelected:          false,
    borderColor:         SemanticUIColor.PURPLE,
    borderColorSelected: SemanticUIColor.TEAL,
    onClick:             null,
} satisfies Partial<GenericEntitySelectionContainerLayoutProps>

function GenericEntitySelectionContainerLayout( { children, ..._props }: GenericEntitySelectionContainerLayoutProps ){

    const props = { ...GenericEntitySelectionContainerLayoutDefaultProps, ..._props };

    const handleOnClick = () => {

        runIfFunction( props.onClick, props.id );
    }

    return (
        <Segment raised key={ props.id } className={ 'no-padding' }>

            <StyledContainer rounded={ true }
                             borderSize={ Size.MD }
                             padding={ [ Size.SM, Size.MD ] }
                             className={ classNames( {
                                 'border--hover':                                      !props.isSelected,
                                 [ `border--colored-${ props.borderColor }` ]:         !props.isSelected,
                                 [ `border--colored-${ props.borderColorSelected }` ]: props.isSelected,
                             } ) }
                             onClick={ handleOnClick }>

                <Grid columns={ `auto 1fr` } columnGap={ '10px' } rowGap={ '0px' }>

                    <Cell className={ 'padding-md-vertical' }>

                        <Icon name={ props.iconName } color={ 'teal' }/>

                    </Cell>
                    <Cell>

                        { children }

                    </Cell>

                </Grid>

            </StyledContainer>

        </Segment>
    );
}

export {
    GenericEntitySelectionContainerLayout,
    GenericEntitySelectionContainerLayoutDefaultProps,
    type GenericEntitySelectionContainerLayoutProps,
};
